document.addEventListener('DOMContentLoaded', () => {
	const doc = document.documentElement;
	let scrolledDown: boolean | null = null;

	const setScrolledDown = () => {
		if (scrolledDown !== false && window.scrollY <= 0) {
			scrolledDown = false;
			doc.classList.remove('has-scrolled-down');
		} else if (scrolledDown !== true && window.scrollY > 0) {
			scrolledDown = true;
			doc.classList.add('has-scrolled-down');
		}
	};

	setScrolledDown();

	window.addEventListener('scroll', setScrolledDown, { passive: true });
});
